<template lang="pug">
    div.row.cf__addWords(v-if="$store.state.isUserLoggedIn")
        div.container.indent
            div.formBlock.wh_bl.mb30
                div.wrapper.wd
                    div.msg__success.is-active(v-if="success" v-html="success")
                    div.msg__error.is-active(v-if="errors" v-html="errors")
                    div.titleBlock.ml10.mb40 Редактирование слова
                        span «{{user.name}}»
                        ul.date
                            li(v-if="user.updatedAt !== 'Invalid date'") Последнее обновления {{user.updatedAt}}
                            li(v-if="user.createdAt !== 'Invalid date'") Дата добавления {{user.createdAt}}
                    div.formGroup.wd50.send
                        label.label
                            div.name Имя *
                            input.input(type='text', v-model="user.name")
                        span.msg

                    div.formGroup.wd50.send
                        label.label
                            div.name Эл. Почта *
                            input.input(type='text', v-model="user.email")
                        span.msg

                    div.formGroup.wd50.send
                        label.label
                            div.name Пароль *
                            input.input(type='text', v-model="user.password")
                        span.msg

                    div.formGroup.wd50.send
                        label.label
                            div.name Новый пароль *
                            input.input(type='text', v-model="user.repeat_password")
                        span.msg

                    div.titleForm Настройки
                    label.controlCheckbox.wd50.ml15
                        input#checkbox.checkbox(type='checkbox', v-model='user.status', true-value='1',  false-value='0', value='')
                        div.control__indicator
                        | Активировать аккаунт:
                        =' '
                        span(v-if="user.status === '1'") да
                        span(v-else) нет

                    div.buttons.section.is-right.ml10.mr10
                        button.btn.btn_large.border.light(@click="save") Сохранить
</template>

<script>
    import {mapState} from 'vuex'
    import UsersService from '@/services/Users';

    export default {
        name: "edit-users",
        data() {
            return {
                user: {
                    id: '',
                    name: '',
                    email: '',
                    password: '',
                    repeat_password: '',
                    status: '',
                    user_can: '',
                    createdAt: '',
                    updatedAt: ''
                },
                success: null,
                errors: null,
                //required: (value) => !!value || 'Required.'
            }
        },
        methods: {
            scrollTop() {
                window.scrollTo(0, document.getElementsByTagName('body').offsetTop);
            },
            async saveNewPass() {

            },
            async save() {
                this.errors = null;
                if (!this.user.name || !this.user.email) {
                    this.scrollTop();
                    return this.errors = 'Пожалуйста, заполните поля.';
                }
                // if (this.user.password !== this.user.repeat_password) {
                //     return this.errors = 'Введенные пароли не совпадают.';
                // }
                try {
                    let res = await UsersService.update({
                        id: this.user.id,
                        name: this.user.name,
                        email: this.user.email,
                        password: this.user.password,
                        repeat_password: this.user.repeat_password,
                        status: this.user.status,
                        user_can: this.user.user_can
                    });
                    this.$store.dispatch('setUser', res.data.user);
                    this.scrollTop();
                    this.success = 'Вы успешно обновили данные пользователя!';
                    setTimeout(() => {
                        this.success = null;
                    }, 2000);
                } catch (error) {
                    this.errors = error.response.data.error
                }
            }
        },
        computed: {
            ...mapState(['isUserLoggedIn']),
            userData() {
                return this.$store.state.user
            },
        },
        async mounted() {
            try {
                this.user.id = this.userData.id;
                this.user.name = this.userData.name;
                this.user.email = this.userData.email;
                this.user.status = this.userData.status;
                this.user.user_can = this.userData.user_can;
                this.user.createdAt = this.userData.createdAt;
                this.user.updatedAt = this.userData.updatedAt;

            } catch (error) {
                console.log(error)
            }
        },
    }
</script>

